<style>
.v-enter-active {
  transition: opacity 1s;
}
.v-enter {
  opacity: 0;
}

</style>
<template>
  <main id="maching_select_main" class="maching_main">
    <section id="result">
      <div class="head-result">
        <h2>
          <img
            src="../assets/img/common/title_rsult.png"
            width="230"
            height="22"
            alt="RESUTL!"
          />
        </h2>
        <p class="txt">あなたが選んだお家とハウスメーカーはこちら!</p>
      </div>
      <transition-group
        tag="ul"
        class="lst-search_items _l3 _company"
        name="iine"
        appear
      >
        <li
          v-for="(val, key) in likeResult"
          :key="key"
          v-bind:class="'item' + key"
        >
          <figure><img :src="val.img" alt="" /></figure>
          <div class="logo">
            <a :href="val.m_url" target="_blank">
              <span class="liq"><img :src="val.logo" :alt="val.name" /></span>
              <p class="logo_name">{{ val.name }}</p>
            </a>
          </div>
          <div class="box-venue">
            <p class="ttl">このメーカーのある会場は</p>
            <div class="box-tag">
              <a v-for="(v, k) in val.exhibition" :key="k" :class="k" :href="v.url" target="_blank">{{
                v.area
              }}</a>
            </div>
          </div>
        </li>
      </transition-group>
      <div class="box-form">
        <ul class="lnk-result_form">
          <li class="btn-form">
            <a href="https://area18.smp.ne.jp/area/switch/00011K00053Aeeq0Ka/catalog" target="_blank">メーカーへの資料請求はこちらから</a>
          </li>
          <li class="btn-form">
            <a href="https://35s.co.jp/chukyotvh/menu/reservation/" target="_blank">モデルハウス見学のご予約はこちらから</a>
          </li>
          <li class="btn-retry"><a :href="url">もう一度診断する</a></li>
        </ul>
      </div>
    </section>
    <section id="no_select" class="box-no_select">
      <h2 class="txt">「…うーん」に選ばれたお家はこちら</h2>
      <ul class="lst-noselect">
        <li v-for="(val, key) in hateResult" :key="key">
          <figure><img :src="val.img" alt="" /></figure>
          <div class="logo">
            <p class="logo_name">{{ val.name }}</p>
          </div>
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
export default {
  name: "Res",
  components: {},
  data: function () {
    return {
      value: 1,
      question: {},
      url: String,
      selectImg: {},
    };
  },
  props: {
    build: String,
  },
  computed: {
    likeResult: function () {
      return this.$store.state.like;
    },
    hateResult: function () {
      return this.$store.state.hate;
    },
  },
  mounted: function () {
    this.url = "/matching/"/*+ this.build */ ;
  },
  methods: {},
  watch: {},
};
</script>
